import { ElementFormatType, FORMAT_ELEMENT_COMMAND } from 'lexical';
import React from 'react';
import { ActionType } from '../components/ActionType';
import ResponsiveToolbar from '../components/ResponsiveToolbar';
import { Icons } from '../icons/Icons';
import { KeyValueMap } from '../KeyValueMap';

export const alignmentStyles: KeyValueMap<string, ActionType> = {
    left: { label: 'lexical.format.left', icon: Icons.FormatAlignLeft },
    center: { label: 'lexical.format.center', icon: Icons.FormatAlignCenter },
    right: { label: 'lexical.format.right', icon: Icons.FormatAlignRight },
    justify: { label: 'lexical.format.justify', icon: Icons.FormatAlignJustify }
};

export default function AlignmentMenuItem({
    disabled,
    editor,
    isSmall,
    isAlignLeft,
    isAlignCenter,
    isAlignRight,
    isAlignJustify
}) {
    const handleAlignment = (newAlignment: ElementFormatType | null) => {
        editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, newAlignment);
    };
    const selected = [];

    return (
        <ResponsiveToolbar
            disabled={disabled}
            isSmall={isSmall}
            options={alignmentStyles}
            onSelect={handleAlignment}
            selected={selected}
            icon={Icons.FormatAlignLeft}
        />
    );
}
